export default {
    fileUploadRam: {
        page: {
            Maximum: '最大容量',
            limit: '文件大小限制',
            details: '查 看 配 置 详 情',
            Used: '已使用容量',
            discard: '是否放弃当前页面数据并重新获取？',
            saving: '您正在保存当前数据，是否继续？'
        },
    },
};
